module.exports = __webpack_public_path__ + "static/media/nas.356c339c.png";